import React, { Component } from "react";
import AutoInput from "../containers/AutoInput";
import withValues from "../hocs/withValues";
import { getValue } from "../utils/models";
import { Icon, Tabs, Button, message } from "antd";
import { FormattedMessage } from "react-intl";
import { request } from "../utils/http";
import custom from "../config/custom";
import List from "../containers/List";

import "../containers/Quote/index.css";

const { TabPane } = Tabs;
class QuoteEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      printing: false,
      date: null,
      instructionletter: null,
      status: null
    };
    this.approved = this.approved.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.values.date !== prevProps.values.date) {
      this.setState({
        date: getValue(this.props.values, "date")
      });
    }
    if (this.props.values.letterId !== prevProps.values.letterId) {
      this.setState({
        letterId: getValue(this.props.values, "letterId")
      });
    }
    if (this.props.values.status !== prevProps.values.status) {
      this.setState({
        status: getValue(this.props.values, "status")
      });
    }
  }

  approved(e) {
    e.stopPropagation();
    request(`${custom.baseUrl}/approve-quote/${this.props.id}`, {
      method: "POST",
      data: { id: this.props.id, letterId: this.props.values.letterId.id }
    })
      .then(() => {
        message.success("Notificacion de arrivo creada");
      })
      .catch(error => {
        message.warning("No se pudo generar la notificacion de arrivo", error);
      });
  }

  printing() {
    window.open(`${custom.baseUrl}/quote-pdf/${this.props.id}/pdf`);
  }

  render() {
    const belongsToProp = {
      belongsTo: {
        association: "quote",
        id: this.props.id,
        date: null,
        instructionletterid: null
      }
    };

    return (
      <div>
        <Tabs defaultActiveKey="1">
          <TabPane
            tab={
              <span>
                <Icon type="form" />
                Arrival Nofication
              </span>
            }
            key="1"
          >
            <AutoInput
              form={this.props.form}
              disabled={this.props.disabled}
              model={"quote"}
              id={this.props.id}
              attribute={"date"}
              value={getValue(this.props.values, "date")}
            />
            <AutoInput
              form={this.props.form}
              model={"quote"}
              attribute={"status"}
              type={"model"}
              autoSave
              items={["PENDIENTE", "ACEPTADO", "RECHAZADO"]}
              onChange={value => {
                this.setState({ status: value });
              }}
              value={getValue(this.props.values, "status")}
            />
            <AutoInput
              form={this.props.form}
              model={"quote"}
              id={this.props.id}
              autoSave
              attribute={"exchangePrice"}
              value={getValue(this.props.values, "exchangePrice")}
            />
            <AutoInput
              form={this.props.form}
              disabled={this.props.disabled}
              model={"quote"}
              id={this.props.id}
              autoSave
              attribute={"clientRef"}
              filter={{ active: true }}
              value={getValue(this.props.values, "clientRef")}
            />

            {/* Botones para aprovar o rechazar cotizacion */}
            <div className="aproveQuote">
              {/* Aceptar cotizacion boton */}
              <Button
                className="aproveQuote"
                type="primary"
                onClick={this.approved}
              >
                Generar Notificacion
              </Button>
            </div>

            <div
              className="aproveQuote"
              hidden={this.state.download}
              size="small"
            >
              <Button
                className="aproveQuote"
                onClick={e => {
                  e.stopPropagation();
                  this.printing();
                }}
                loading={this.state.printing}
              >
                <Icon type="file-text" />
                Print
              </Button>
            </div>
          </TabPane>
          <TabPane
            tab={<FormattedMessage id={"Attribute.quote.locals"} />}
            key="local"
          >
            <List model="local" {...belongsToProp} />
          </TabPane>
          <TabPane
            tab={<FormattedMessage id={"Attribute.quote.maritimos"} />}
            key="maritimos"
          >
            <List model="maritime" {...belongsToProp} />
          </TabPane>
          <TabPane
            tab={<FormattedMessage id={"Attribute.quote.aamx"} />}
            key="aamx"
          >
            <List model="aamx" {...belongsToProp} />
          </TabPane>
          <TabPane
            tab={<FormattedMessage id={"Attribute.quote.terrestre"} />}
            key="land"
          >
            <List model="land" {...belongsToProp} />
          </TabPane>
          <TabPane
            tab={<FormattedMessage id={"Attribute.quote.profits"} />}
            key="profits"
          >
            <List model="profitandloses" {...belongsToProp} />
          </TabPane>
        </Tabs>
      </div>
    );
  }
}

export default withValues(QuoteEdit);



// WEBPACK FOOTER //
// ./src/forms/QuoteEdit.js